import { i18n } from "@lingui/core";
import { createFileRoute } from "@tanstack/react-router";

import { MyPasskeysAccountPage } from "@/views/account/passkeys";

export const Route = createFileRoute("/_authenticated/account/passkeys")({
  component: MyPasskeysAccountPage,
  loader() {
    return {
      breadcrumbLabel: i18n._("account.passkeys.breadcrumb"),
    };
  },
});
